// extracted by mini-css-extract-plugin
export default {"geoMap":"GeoMap_geoMap__CxNOU","fullGeoMap":"GeoMap_fullGeoMap__oLV+J"};